import(/* webpackMode: "eager", webpackExports: ["ProtectedLayoutClient"] */ "/vercel/path0/src/app/(protected)/protected-layout-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/AppFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/ProtectedGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DraftAlertClient"] */ "/vercel/path0/src/components/misc/DraftAlert/Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/BackToTop.tsx");
